import { Component, OnInit } from '@angular/core';
import { EaccessAuthService } from '../../auth/eaccess-auth.service';
import { ROLE_AUDIT_TRAIL_TRANSACTION_NOTES_DISTRIBUTION_READ } from '../../shared/constants';

@Component({
  selector: 'eaa-can-view-audit-trail-transaction-notes-distribution',
  template: `
    @if (canView) {
      <ng-content></ng-content>
    }
  `
})
export class CanViewAuditTrailTransactionNotesDistributionComponent implements OnInit {
  public canView: boolean | null = null;

  constructor(private authService: EaccessAuthService) {}

  public ngOnInit(): void {
    this.authService
      .hasRole$(ROLE_AUDIT_TRAIL_TRANSACTION_NOTES_DISTRIBUTION_READ)
      .subscribe((hasRole) => (this.canView = hasRole));
  }
}
